import { Component, HostListener } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { DriverRecordRequestService } from '../../../services/driverrecordrequest.service';
import { GeneralService } from '../../../services/general.service';
import { IWizard } from '../../../interfaces/iwizard';
import { WizardSteps } from '../../../interfaces/wizard-steps';
import { Router } from '@angular/router';
import { ContactFormInfo } from '../../../interfaces/contact-form-info';

@Component({
    selector: 'app-id-verify-fail',
    templateUrl: './id-verify-fail.component.html',
    styleUrls: ['./id-verify-fail.component.scss'],
    standalone: false
})
export class IdVerifyFailComponent {

     form!: FormGroup;
     public wizard!: IWizard;
     _step = 11;

     contactFormInfo: ContactFormInfo | any;
     
     constructor (public _router: Router, public service: DriverRecordRequestService, public generalService: GeneralService) {
          this.setContactInfo();
          this.wizard = this.service.getWizard();
     }

     ngOnInit(): void {
          setTimeout(() => this.scrollToTop(), 500);
          this.generalService.logActivity('driver_id_verify_quiz::fail',this.service.driverRequest!.emailAddress!);
          if (this.service.justSubscribe) {
               this._step = 8;
          }
     }

     setContactInfo() {
          let driverName = this.service.driverRequest.firstName + ' ' + this.service.driverRequest.lastName;
          if (!this.service.driverRequest.firstName || !this.service.driverRequest.lastName) {
               driverName = '';
          }
          this.contactFormInfo = {
               contactName: driverName,
               contactEmail: this.service.driverRequest.emailAddress,
               errorSummary: this.translate('IDVerifyFailSummary'),
               header: this.translate('IDVerifyFailHeader'),
               message: '',
               optionalReason: this.translate('IDVerifyFailOptional'),
               contactPhone: this.service.driverRequest.address?.phoneNumber,
               topic: 'Identity Cannot Be Verified',
          }
          
     }

     translate(translationTag: string) {
          let translatedText: string = this.generalService.getTranslation(translationTag)
          if (translatedText === undefined) {
               translatedText = this.generalService.getTranslation(translationTag);
          }
          return translatedText;
     }

     scrollToTop() {
          window.scrollTo(0, 0);
     }

     @HostListener('window:beforeunload', ['$event'])
     unloadMessage($event: { returnValue: string; }) {
          return $event.returnValue = 'Your changes will not be saved';
     }

}
